const apiUrl = process.env.REACT_APP_API_URL;

const deleteMaintenanceActivity = (token, id, cb) => {
    fetch(`${apiUrl}/maintenanceactivities/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default deleteMaintenanceActivity;
